import { array, number, object, string } from "yup";
import {
  CurrentSubscriptionFeatureResource,
  currentSubscriptionFeatureResourceSchema,
} from "./CurrentSubscriptionFeatureResource";
import {
  PriceMoneyResource,
  priceMoneyResourceSchema,
} from "./PriceMoneyResource";

export interface AvailableSubscriptionAddonPriceResource {
  uuid: string;
  money: PriceMoneyResource;
}

export interface AvailableSubscriptionAddonAddonResource {
  id: number;
  name: string;
  features: CurrentSubscriptionFeatureResource[];
}

export interface AvailableSubscriptionAddonResource {
  id: number;
  addon: AvailableSubscriptionAddonAddonResource;
  limit: number;
  price: AvailableSubscriptionAddonPriceResource;
}

const availableSubscriptionAddonPriceResourceSchema = object({
  uuid: string().required(),
  money: priceMoneyResourceSchema.required(),
});

const availableSubscriptionAddonAddonResourceSchema = object({
  id: number().required(),
  name: string().required(),
  features: array(currentSubscriptionFeatureResourceSchema).required(),
});

export const availableSubscriptionAddonResourceSchema = object({
  id: number().required(),
  addon: availableSubscriptionAddonAddonResourceSchema.required(),
  limit: number().required(),
  price: availableSubscriptionAddonPriceResourceSchema.required(),
});
